/* eslint-disable import/no-named-as-default */
"use client";

import { Vehicle } from "@alba-cars/common-modules";
import { useLocale, useTranslations } from "next-intl";
import { useRouter, useSearchParams } from "next/navigation";
import { useState } from "react";

import PhoneNumberModal from "@/components/common/modals/PhoneNumberModal";
import Button from "@/components/ui/buttons/Button";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { initiateCallUs } from "@/lib/analytics/openai-events";
import { slugify } from "@/lib/utils";
import { isReservedConsignment } from "@/lib/vehicle-ownership";
import { phoneNumber } from "@/utils/constants";

interface MobileButtonsProps {
  car: Vehicle;
}

export default function MobileButtons({ car }: MobileButtonsProps) {
  const t = useTranslations("CarDetails.sidebar");
  const locale = useLocale();
  const router = useRouter();
  const searchParams = useSearchParams();
  const [isPhoneNumberModalOpen, setIsPhoneNumberModalOpen] = useState(false);

  const isTabletOrLarger = useMediaQuery("(min-width: 768px)");
  const isPurchaseDisabled = isReservedConsignment(car);

  const trim = car?.trim ?? "";
  const refId = car?.refId ?? "";
  const make = car?.make?.name ?? "";
  const model = car?.model?.name ?? "";
  const detailLink = trim
    ? `${refId}-${slugify(make)}-${slugify(model)}-${slugify(trim)}`
    : `${refId}-${slugify(make)}-${slugify(model)}`;

  return (
    <>
      <div className="flex gap-4">
        <Button
          buttonText={t("callUs")}
          bgColor="primary-light"
          textColor="primary"
          className="my-2 w-1/2 py-4 text-center hover:bg-primary hover:text-white"
          onClick={() => {
            initiateCallUs({
              phone: phoneNumber,
              isDesktop: isTabletOrLarger,
              onOpenModal: () => setIsPhoneNumberModalOpen(true),
              source: "car_mobile_call_us",
            });
          }}
        />
        <Button
          buttonText={t("buyThisCar")}
          bgColor="primary-light"
          textColor="primary"
          disabled={isPurchaseDisabled}
          className="my-2 w-1/2 py-4 text-center transition-all duration-300 ease-in-out hover:bg-primary hover:text-white disabled:cursor-not-allowed disabled:opacity-50"
          onClick={() => {
            if (isPurchaseDisabled) {
              return;
            }

            const params = new URLSearchParams(searchParams);
            params.set("deposit", "5000");
            router.push(`/${locale}/book_car/${detailLink}?${params.toString()}`);
          }}
        />
      </div>
      <PhoneNumberModal
        isOpen={isPhoneNumberModalOpen}
        onClose={() => setIsPhoneNumberModalOpen(false)}
        phoneNumber={phoneNumber}
        trackingSource="car_mobile_call_us"
      />
    </>
  );
}
